<template>
  <div
    :class="'Tabbed-' + orient"
    class="Tabbed row"
  >
    <template v-if="orient === 'vertical'">
      <div class="Tabbed-controls col-md-3">
        <Panel>
          <ul slot="body">
            <li
              v-for="tab in tabs"
              @click="activeTab = tab"
              class="Tab"
              :class="{
                'Tab--active' : activeTab === tab
              }"
            >
              {{ tab }}
            </li>
          </ul>
        </Panel>
      </div>

      <div class="col-md-9">
        <div
          v-for="tab in tabs"
          v-if="activeTab === tab"
          :key="tab"
        >
          <slot :name="tab">
            {{ tab }}
          </slot>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="Tabbed-controls col-md-12">
        <ul>
          <li
            v-for="tab in tabs"
            @click="activeTab = tab"
            class="Tab"
            :class="{
              'Tab--active' : activeTab === tab
            }"
          >
            {{ tab }}
          </li>
        </ul>
      </div>

      <div class="col-md-12">
        <div
          v-for="tab in tabs"
          v-if="activeTab === tab"
          :key="tab"
        >
          <slot :name="tab">
            {{ tab }}
          </slot>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import Panel from '@/legacy/components/widgets/Panel';

  export default {
    components: {
      Panel
    },

    props: {
      tabs: {
        type: Array,
        validator: function (tabs) {
          return tabs.length > 0;
        }
      },

      orient: {
        type: String,
        default: 'vertical'
      }
    },

    data: function () {
      return {
        activeTab: this.tabs [0]
      }
    }
  };
</script>

<style lang="scss">
  .Tabbed {
    &-controls {
      .Panel {
        background:
          asset('background/card-6.png')               no-repeat,
          asset('background/card-6-repeat.png') center repeat-y;
      }

      .Panel-header {
        display: none;
      }

      ul {
        display: block;
        list-style-type: none;
        padding: 0;
        margin: 0;

        li {
          font-size: fetch(font l);
          padding: 6px 0;

          &:hover {
            cursor: pointer;
          }
        }
      }
    }

    &-vertical > &-controls {
      ul {
        li {
          border: none !important;
        }
      }
    }

    &-horizontal > &-controls {
      ul {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        li {
          margin-left: 10px;
          margin-right: 10px;
          padding-left: 10px;
          padding-right: 10px;
        }
      }
    }

    > div {
      padding: 0 15px;
    }

    .Panel {
      margin-top: 0 !important;
    }
  }
</style>